var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignatureWidgetEs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 13884",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v70H0z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v68h98V1H1M0 0h100v70H0V0z",
    style: {
      fill: "#333",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7740"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Signature_no",
    transform: "translate(20 54)",
    style: {
      fontSize: 14,
      fontFamily: "Roboto-Medium,Roboto",
      fontWeight: 500,
      fill: "#333"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Firma"))), /*#__PURE__*/React.createElement("path", {
    d: "M16.007 10.879 10 16.886l-6.007-6.007 1.1-1.1L9.219 13.9V0h1.563v13.9L14.9 9.774zM20 18.437H0V20h20zm0 0",
    transform: "translate(40 13)",
    style: {
      fill: "#333"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureWidgetEs);
export default __webpack_public_path__ + "static/media/signature-widget-es.4aceb88e1e65b8c96d0bf23a6ae1202b.svg";
export { ForwardRef as ReactComponent };